import { Grid } from '@material-ui/core';
import {
  EntityAboutCard,
  EntityLayout,
  EntityLinksCard,
  EntitySwitch,
} from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import {
  isMarketplaceAiResourceEntity,
  isPluginAiResourceEntity,
} from '@backstage/catalog-model/alpha';

import { EntityMarkdownCard } from '../EntityMarkdown/EntityMarkdownCard';
import {
  AiResourceHasPluginsCard,
  AiResourceHasSkillsCard,
} from '../AiResourceRelationCards/AiResourceRelationCards';
import { MarketplaceInstallCard, PluginInstallCard } from '../AiResourceInstallCards';
import { EntityWarningContent } from './EntityWarningContent';
import { techdocsContent } from './TechdocsContent';

export const AiResourceEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <EntityWarningContent />
        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <EntityAboutCard />
            </Grid>
            <EntitySwitch>
              <EntitySwitch.Case if={isMarketplaceAiResourceEntity}>
                <Grid item xs={12}>
                  <MarketplaceInstallCard />
                </Grid>
              </EntitySwitch.Case>
              <EntitySwitch.Case if={isPluginAiResourceEntity}>
                <Grid item xs={12}>
                  <PluginInstallCard />
                </Grid>
              </EntitySwitch.Case>
            </EntitySwitch>
            <Grid item xs={12}>
              <EntityLinksCard />
            </Grid>
            <Grid item xs={12}>
              <EntityMarkdownCard />
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <EntityCatalogGraphCard height={200} />
            </Grid>
            <EntitySwitch>
              <EntitySwitch.Case if={isMarketplaceAiResourceEntity}>
                <Grid item xs={12}>
                  <AiResourceHasPluginsCard />
                </Grid>
              </EntitySwitch.Case>
              <EntitySwitch.Case if={isPluginAiResourceEntity}>
                <Grid item xs={12}>
                  <AiResourceHasSkillsCard />
                </Grid>
              </EntitySwitch.Case>
            </EntitySwitch>
          </Grid>
        </Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/docs" title="Docs">
      {techdocsContent}
    </EntityLayout.Route>
  </EntityLayout>
);
